import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GoApplicationPreparationBaseComponent } from '../shared/components/go-application-preparation-base/go-application-preparation-base.component';
import { GoApplicationRequestFormModel } from '../shared/models/go-application-request-form-model';
import { GoApplicationPurposeSelectionComponent } from '../shared/components/go-application-purpose-selection/go-application-purpose-selection.component';
import { FormGroup } from '@angular/forms';
import { FormGroupType } from '../../../../core/models/form-group-type';
import { MatExpansionModule } from '@angular/material/expansion';

import { GoParametersSummaryComponent } from '../shared/components/go-parameters-summary/go-parameters-summary.component';

@Component({
    selector: 'app-go-confirm-parameters',
    imports: [
        GoApplicationPurposeSelectionComponent,
        MatExpansionModule,
        GoParametersSummaryComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './go-confirm-parameters.component.html',
})
export class GoConfirmParametersComponent
    extends GoApplicationPreparationBaseComponent<GoApplicationRequestFormModel>
    implements OnInit
{
    form: FormGroup<FormGroupType<GoApplicationRequestFormModel>> =
        this.goApplicationRequestForm;

    hasChanges = false;

    protected override shouldSubmit(): boolean {
        return true;
    }

    protected override beforeStepContinue(): Promise<boolean> {
        // No additional actions needed before moving to the next page
        return Promise.resolve(true);
    }

    protected override patchFormWithGoApplicationRequestFormValue(): void {
        const cachedForm = this.goStorageService.getGoParametersFormCacheData();
        const formValue = cachedForm ?? this.goApplicationRequestForm.value;

        this.form.patchValue(formValue);
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.patchFormWithGoApplicationRequestFormValue();

        this.goApplicationPreparationService.updateGoApplicationFormControls(
            this.form,
        );

        this.goApplicationPreparationService.updateSectionControls(
            this.form as unknown as FormGroup<
                FormGroupType<GoApplicationRequestFormModel>
            >,
        );
    }

    protected override scrollToFirstInvalidElement(): void {
        // No need to implement, this page does not have input elements
    }
}
